import { useEffect } from "react";
import { deleteListaDet, getListaDetPanel,getListaDetById } from "../../services/ListaDetServices";
import { ListasDetContext } from "./ListasDetContext"

export const ListasDetState = ({ children }) => {

    const getListaDetPanelData = async (lpid,searchArtId, numPagina, filas) => {
        let res = await getListaDetPanel(lpid,searchArtId, numPagina, filas)
        return res
    }

    const deleteListaDetData = async (body) => {
        const res = await deleteListaDet(body)
        if (res) getListaDetPanelData()
        return res
    }

    const getListaDetByIdData = async (id) => {
        let res = await getListaDetById(id)
        return res
    }


    return <ListasDetContext.Provider value={{
        deleteListaDetData,
        getListaDetPanelData,
        getListaDetByIdData
    }} >
        {children}
    </ListasDetContext.Provider>
}